export enum BotMigrationStatus {
  Success = 'Migration successful.',
  Skipped = 'BotMigration skipped (media already migrated).'
}

export enum GeneralInfo {
  RequestAccepted = 'Request already accepted.'
}

export enum VersionTitleStartingPart {
  MediaGalleryMigration = 'Migrated media to server storage for bot'
}
